import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function StatusModal({id, status, show, handleClose, handleStatus, setIsLoading}) {
  const updateStatus = () => {
    setIsLoading(true);
    handleClose();
    handleStatus(id, status);
  };

  return (
    <Modal
        show={show}
        onHide={handleClose}
        size='lg'
        className='invoice-modal max-heighted-modal'
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body className='custom-scrollbar'>
            <p>Do you really want to update the status?</p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='secondary' size='sm' onClick={handleClose}>
                No
            </Button>
            <Button variant='primary' size='sm' onClick={updateStatus}>
                Yes
            </Button>
        </Modal.Footer>
    </Modal>
  )
}
